import { useEffect, useState } from "react";
import api from "../components/api/api";
import stringHelpers from "./stringHelpers";
let _abortController = null;
export const useBreachStatusCounts = (breachStatus, organisationId, token, isStatusChange, from = null, to = null) => {
    // use this custom hook to get details for any breach status
    // in future we can add other state variables if needed which makes it versatile
    const [totalCount, setTotalCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    _abortController = new AbortController();
    const signal = _abortController.signal;
    const renderValue = () => {
        setIsLoading(true)
        if (isStatusChange) {
            api.getBreachStatusChangeReport(
                data => {
                    setTotalCount(stringHelpers.formatDecimal(data.length, 0))
                    setIsLoading(false)
                },
                error => { console.log(error); setIsLoading(false) },
                from, to, null, breachStatus, null, null, 0, organisationId, token, signal
            )
        } else {
            api.getBreaches(
            data => {
                setTotalCount(stringHelpers.formatDecimal(data.totalCount, 0))
                setIsLoading(false)
            },
            error => { console.log(error); setIsLoading(false) },
            null, null, null, null, from, to, null, [breachStatus], null, 0, 0, null, null, null,
            null, null,
            null,
            organisationId, token, signal
            )
        }
    }

    useEffect(() => renderValue(), [breachStatus])

    return {
        totalCount,
        isLoading
    }
}